module.exports = __webpack_public_path__ + "images/emoji/see_no_evil.d82ccdc54e8b09c7eab7.png";